export const ATLAS_PORTAL_HOSTNAME = "atlas.creativestrategies.com";
export const ATLAS_PORTAL_ORIGIN = `https://${ATLAS_PORTAL_HOSTNAME}`;

export const LEGACY_PORTAL_HOSTNAME = "portal.thediligencestack.com";
export const LEGACY_PORTAL_ORIGIN = `https://${LEGACY_PORTAL_HOSTNAME}`;

export const ATLAS_CREDENTIAL_MIGRATION_VERSION = 1;

export function normalizePortalOrigin(value: string | undefined | null) {
  if (!value?.trim()) return null;
  try {
    return new URL(value.trim()).origin;
  } catch {
    return null;
  }
}

export function isAtlasPortalOrigin(value: string | undefined | null) {
  return normalizePortalOrigin(value) === ATLAS_PORTAL_ORIGIN;
}

export function resolvePasskeyRpId(rpId: string | undefined | null) {
  return rpId?.trim() || LEGACY_PORTAL_HOSTNAME;
}
